//@flow
import * as React from 'react';
import SelectInput from './SelectInput';
import _ from 'lodash';
type Props = {
  label: string,
  name: string,
  value: any,
  onChange: any,
  returnFullObject: boolean,
  messageValidate?: any,
  disabled?: boolean,
  size?: number,
  required: boolean,
  service?: any,
  onFetchData?: any,
  parent?: any,
  defaultParent?: any,
  minSearchLength?: number,
  debounceMs?: number,
  cache?: boolean,
};

type State = {
  options: Array<any>,
};
export default class FormSelectInput extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    console.log('erroMensagem', this.props.erroMensagem);

    this.state = {
      options: [],
    };
  }

  carregarOpcoes = (props) => {
    if (props.onFetchData || !props.service) {
      return;
    }

    props.service(props.parent).then(
      (data) => {
        const options = Array.isArray(data)
          ? data
          : data && Array.isArray(data.data)
          ? data.data
          : [];
        this.setState({ options: options });
      },
      (error) => {
        console.log('Erro ao montar o combo', error);
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.onFetchData) {
      if (!this.props.onFetchData) {
        this.setState({ options: [] });
      }
      return;
    }

    if (
      !_.isEqual(nextProps.parent, this.props.parent) ||
      !_.isEqual(nextProps.defaultParent, this.props.defaultParent)
    ) {
      this.carregarOpcoes(nextProps);
    }
  }
  componentDidMount() {
    this.carregarOpcoes(this.props);
  }

  render() {
    return (
      <SelectInput
        multi={this.props.multi}
        isMulti={this.props.isMulti}
        allowSelectAll={this.props.allowSelectAll}
        clearable={this.props.clearable}
        searchable={this.props.searchable}
        id={this.props.id}
        label={this.props.label}
        valueKey={this.props.valueKey ? this.props.valueKey : 'id'}
        labelKey={this.props.labelKey ? this.props.labelKey : 'nome'}
        name={this.props.name}
        value={this.props.value}
        options={this.props.onFetchData ? [] : this.state.options}
        onFetchData={this.props.onFetchData}
        parent={this.props.parent}
        defaultParent={this.props.defaultParent}
        minSearchLength={this.props.minSearchLength}
        debounceMs={this.props.debounceMs}
        cache={this.props.cache}
        onChange={this.props.onChange}
        returnFullObject={this.props.returnFullObject}
        messageValidate={this.props.messageValidate}
        disabled={this.props.disabled}
        size={this.props.size}
        style={this.props.style}
        required={this.props.required}
        noSize={this.props.noSize}
        erroMensagem={this.props.erroMensagem}
      />
    );
  }
}
